<app-header [label]="page_name"></app-header>

<app-ag-grid-list [list]="items" [colDefs]="columns" [bulk_delete]="false" [show_checkboxes]="false" [itemName]="page_name" (fetch_new_list)="get_list($event)" main_description="No activity logs found" description="Try adjusting filters to view logs">
  <div filters class="flex gap-3 justify-between items-center w-full flex-wrap">
    <div class="flex gap-3 flex-wrap">
      <app-select-input label="Role" class="w-44" [options]="role_options" [(ngModel)]="params.role_id" (valueChange)="apply_filters()"></app-select-input>
      <!-- <app-select-input label="User Name" class="w-44" [options]="user_options" [(ngModel)]="params.user_id" (valueChange)="apply_filters()"></app-select-input>
      <app-select-input label="Module" class="w-44" [options]="entity_options" [(ngModel)]="params.entity" (valueChange)="apply_filters()"></app-select-input>
      <app-select-input label="Action" class="w-40" [options]="action_options" [(ngModel)]="params.action" (valueChange)="apply_filters()"></app-select-input> -->
    </div>

    <div class="flex gap-3 items-center">
      <app-search-input (valueChange)="get_list({ search: $event, page: 1 })"></app-search-input>
      <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="download()"></app-button>
    </div>

  </div>
</app-ag-grid-list>